import { SVGIconProps } from 'fe-design-base/atoms/Icon/Icon';

const SvgMegaphone = ({
  alt = 'Megaphone Icon',
  id,
  screenReadable = false,
}: SVGIconProps) => (
  <svg
    {...(screenReadable
      ? { role: 'img', 'aria-labelledby': id }
      : { 'aria-hidden': 'true' })}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
  >
    {screenReadable && <title id={id}>{alt}</title>}
    <path
      d="M20.75 9.01625C21.4531 9.36822 22 10.3068 22 11.3627C22 12.4577 21.4531 13.3963 20.75 13.7483V19.4971C20.75 20.0055 20.4375 20.4748 19.9688 20.6703C19.5 20.8659 18.9531 20.7486 18.6016 20.3966L16.8828 18.6758C15.0078 16.7987 12.4688 15.7428 9.8125 15.7428H9.5V20.7486C9.5 21.4525 8.91406 22 8.25 22H5.75C5.04688 22 4.5 21.4525 4.5 20.7486V15.7428C3.09375 15.7428 2 14.6478 2 13.2399V9.48555C2 8.11678 3.09375 6.98266 4.5 6.98266H9.8125C12.4688 6.98266 15.0078 5.92675 16.8828 4.08869L18.6016 2.36795C18.9531 2.01598 19.5 1.89866 19.9688 2.0942C20.4375 2.28974 20.75 2.75903 20.75 3.22832V9.01625ZM9.8125 9.48555H9.5V13.2399H9.8125C12.9375 13.2399 15.9453 14.4131 18.25 16.5249V6.23961C15.9453 8.35142 12.9375 9.48555 9.8125 9.48555Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgMegaphone;
